
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConnectorCross as ObiConnectorCrossElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-connector-cross.js';
 
 
 

 
 export const ObiConnectorCross = createComponent({
   react: React,
   tagName: 'obi-connector-cross',
   elementClass: ObiConnectorCrossElement,
   events: {
     
   }
  });
 
 